import { render, staticRenderFns } from "./VRowWrapper.vue?vue&type=template&id=0af88031"
import script from "./VRowWrapper.vue?vue&type=script&lang=js"
export * from "./VRowWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports